import { repeatedRequest } from './repeatedRequest'

export const redirectHtml = redirect_html => {
  try {
    $('#3ds').show()
    $('#3ds-html').html(redirect_html)
  } catch (e) {
    console.error('redirect_html' + ': ' + e)
  }

  setTimeout(function () {
    const form = $('#3ds-html form')
    form.submit()
    setTimeout(function () {
      repeatedRequest()
    }, 3000)
  }, 1000)
}
